import type { StoreRecord } from './chefShared'

export const dishIdentityKey = (row: StoreRecord): string => {
  const name = String(row.name ?? '').trim().toLocaleLowerCase()
  if (!name) return String(row.id ?? '')
  const owner = String(row.chef_profile_id ?? '')
  const category = String(row.category ?? '').toLocaleLowerCase()
  const price = Number(row.price_minor ?? 0)
  return `${owner}\u0000${name}\u0000${category}\u0000${price}`
}

/** Menu copies represent one dish in the chef's reusable library. */
export const uniqueDishLibrary = (rows: readonly StoreRecord[]): StoreRecord[] => {
  const byDish = new Map<string, StoreRecord>()
  for (const row of rows) {
    const key = dishIdentityKey(row)
    const current = byDish.get(key)
    const active = (dish: StoreRecord) => dish.status !== 'hidden' && dish.status !== 'DISH_STATUS_HIDDEN'
    if (!current || (active(row) && !active(current)) ||
      (active(row) === active(current) && !row.menu_id && current.menu_id)) byDish.set(key, row)
  }
  return [...byDish.values()]
}

export const canonicalDishIds = (
  attached: readonly StoreRecord[],
  library: readonly StoreRecord[],
): Set<string> => {
  const canonical = new Map(library.map((dish) => [dishIdentityKey(dish), String(dish.id)]))
  return new Set(attached.map((dish) => canonical.get(dishIdentityKey(dish)) ?? String(dish.id)))
}

/** The editor displays current menu copies and permits one selection per name. */
export const menuDishLibrary = (rows: readonly StoreRecord[], menuId?: string): StoreRecord[] => {
  const byName = new Map<string, StoreRecord>()
  const rank = (dish: StoreRecord) =>
    (menuId && dish.menu_id === menuId ? 100 : 0) +
    (dish.status === 'hidden' || dish.status === 'DISH_STATUS_HIDDEN' ? 0 : 10) +
    (!dish.menu_id ? 1 : 0)
  for (const dish of rows) {
    const key = JSON.stringify([dish.chef_profile_id, dish.name])
    const current = byName.get(key)
    if (!current || rank(dish) > rank(current)) byName.set(key, dish)
  }
  return [...byName.values()]
}
